import { create } from 'zustand';

interface UploadQueueGuardStore {
  isDialogOpen: boolean;
  pendingAction: (() => void) | null;
  totalFilesCountOnOpen: number;
  shouldExecutePendingActionOnClose: boolean;
  openDialog: (action: () => void, totalFilesCount: number) => void;
  closeDialog: () => void;
  markExecuteOnClose: () => void;
  clearPendingAction: () => void;
}

export const useUploadQueueGuardStore = create<UploadQueueGuardStore>(set => ({
  isDialogOpen: false,
  pendingAction: null,
  totalFilesCountOnOpen: 0,
  shouldExecutePendingActionOnClose: false,
  openDialog: (action, totalFilesCount) =>
    set({
      isDialogOpen: true,
      pendingAction: action,
      totalFilesCountOnOpen: totalFilesCount,
      shouldExecutePendingActionOnClose: false,
    }),
  closeDialog: () => set({ isDialogOpen: false }),
  markExecuteOnClose: () => set({ shouldExecutePendingActionOnClose: true }),
  clearPendingAction: () =>
    set({
      pendingAction: null,
      totalFilesCountOnOpen: 0,
      shouldExecutePendingActionOnClose: false,
    }),
}));
